import { FETCH_GET } from "../../config";

export const GET_ANNOUNCEMENTS_PENDING = "GET_ANNOUNCEMENTS_PENDING";
export const GET_ANNOUNCEMENTS_FULFILLED = "GET_ANNOUNCEMENTS_FULFILLED";
export const GET_ANNOUNCEMENTS_REJECTED = "GET_ANNOUNCEMENTS_REJECTED";

export const getAllAnnouncements = () => {
  const query = `query={getAllAnnouncementsData{id,title,link}}`;
  return async (dispatch) => {
    dispatch({ type: GET_ANNOUNCEMENTS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: GET_ANNOUNCEMENTS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: GET_ANNOUNCEMENTS_FULFILLED,
          payload: result.data.data.getAllAnnouncementsData,
        });
      }
    } catch (e) {
      dispatch({ type: GET_ANNOUNCEMENTS_REJECTED, payload: e });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/announcement.js